export default __webpack_public_path__ + "static/media/gallery-wip-ammo-port-enclosure-box_00.14b9cee7.jpg";